import { Box, Stack, TableCell, Typography } from '@mui/material'

type Props = {
  text: string | number;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}

export default function CustomTableCell({ text, className }: Props) {
  return (
    <TableCell>
      <Stack className={className} spacing={2} direction="row" >
        <Box>
          <Typography color="black" fontSize={14} variant="h6" fontWeight="400">
            {text}
          </Typography>
        </Box>
      </Stack>
    </TableCell>
  )
}
